import React from 'react';
import PropTypes from 'prop-types';
import styles from './AboutModal.module.css';

const AboutModal = ({ show, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        <h2>About Onserv</h2>
        <p>Onserv Trader Agent is a cutting-edge platform for backtesting trading strategies. Our mission is to provide powerful tools and insights to help you make informed trading decisions.</p>
      </div>
    </div>
  );
};

AboutModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AboutModal;